import React, { useState, useEffect} from 'react';
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  IconButton,
  styled,
  ThemeProvider,
  createTheme,
  // Dialog,
  // DialogContent,
  // DialogTitle,
  // DialogActions
} from '@mui/material';
import {
  Visibility,
  VisibilityOff,
  Email,
  Lock
} from '@mui/icons-material';
import axios from "axios";
import SubmittedMessage from './components/submittedMessage';
import Loader from "./circularProgress";
// Custom styled components
const StyledCard = styled(Card)(({ theme }) => ({
  maxWidth: 450,
  margin: '0 auto',
  padding: theme.spacing(2),
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
  borderRadius: 12,
}));

const FormTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderRadius: 8,
    },
    '&:hover fieldset': {
      borderColor: theme.palette.primary.main,
    },
  },
}));

// Create custom theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#2563eb',
    },
    secondary: {
      main: '#64748b',
    },
  },
  typography: {
    h5: {
      fontWeight: 600,
    },
    body2: {
      color: '#64748b',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
          textTransform: 'none',
          fontSize: '1rem',
        },
      },
    },
  },
});



const LoginForm = ({setUserData, onHandleToggle, showPassword }) => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [formError, setFormError] = useState({ email: "", password: "" });
  const [isLogin, setLogin] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false); // PDS - 31561

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    const updatedForm = { ...formData, [name]: value };
    setFormData(updatedForm);
    validateInputField(name, value);
  };

  const validateInputField = (name, value) => {
    let errorMessage = "";

    switch (name) {
      case "email":
        if (!value.trim()) {
          errorMessage = "Email id is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          errorMessage = "Please Enter Valid Email Id";
        }
        break;
      case "password":
        if (!value) {
          errorMessage = "Password is required";
        } 
        
        break;
      default:
        break;
    }

    setFormError(prevErrors => ({
      ...prevErrors,
      [name]: errorMessage,
    }));

    // validateForm();
  };
  useEffect(() => {
      const isValid = Object.values(formError).every(error => !error) &&
                      Object.values(formData).every(value => value !== '')
                     
      setLogin(isValid);
    }, [formData, formError]);

  const API_URL = process.env.REACT_APP_BASE_URL;
  
  const handleLogin = async (evt) => {
    // console.log("url: ",API_URL)
    evt.preventDefault();
    setIsLoading(true)
    try {
        const response = await axios.post(`${API_URL}/login`, formData, {
            headers: { "Content-Type": "application/json" }
        });

        const { user } = response.data; // Extract user data and submission status

        setUserData(user); // Store user data in state

        if (user.hasSubmitted) {
          setOpenPopup(true);
          
        } else {
            navigate('/details'); // Allow user to fill the form
        }

    } catch (err) {
        console.error("Login failed:", err);
        alert(err.response?.data?.error || "Something went wrong!");
    }finally {
      setIsLoading(false);
    }

};

function handleClose() {
  setOpenPopup(false);
}

  return (
    <ThemeProvider theme={theme}>
      <StyledCard>
        <CardContent>
          <div style={{ position: 'relative' }}>
          <Box component="form" onSubmit={handleLogin} sx={{ mt: 2 }}>
            <Typography variant="h5" gutterBottom>
              Login
            </Typography>
            <Typography variant="body2" sx={{ mb: 3 }}>
              Enter your credentials to login
            </Typography>

            <FormTextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              onBlur={() => validateInputField("email", formData.email)}
              error={!!formError.email}
              helperText={formError.email}
              sx={{
                '& .MuiInputBase-root': {
                  paddingLeft: 0,
                }
              }}
              InputProps={{
                startAdornment: (
                  <Email color="action" sx={{ ml: 1, mr: 1 }} />
                ),
              }}
            />

            <FormTextField
              fullWidth
              label="Password"
              name="password"
              type={showPassword ? "text" : "password"}
              value={formData.password}
              onChange={handleChange}
              onBlur={() => validateInputField("password", formData.password)}
              error={!!formError.password}
              helperText={formError.password}
              sx={{
                '& .MuiInputBase-root': {
                  paddingLeft: 0,
                }
              }}
              InputProps={{
                startAdornment: (
                  <Lock color="action" sx={{ ml: 1, mr: 1 }} />
                ),
                endAdornment: (
                  <IconButton
                    onClick={onHandleToggle}
                    edge="end"
                  >
                    {showPassword ? <Visibility/> : <VisibilityOff />}
                  </IconButton>
                ),
              }}
            />

            {/* <Typography
              variant="body2"
              sx={{
                textAlign: 'right',
                mb: 2,
                cursor: 'pointer',
                color: 'primary.main',
                '&:hover': {
                  textDecoration: 'underline',
                }
              }}
            >
              Forgot Password?
            </Typography> */}

            

            <Button
              fullWidth
              variant="contained"
              type="submit"
              disabled={!isLogin}
              size="large"
              sx={{ mb: 2 }}
            >
              Login
            </Button>
            {/* {isLoading && <Loader/>} */}

            {isLoading && (
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.6)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1,
        }}
      >
        <Loader />
      </Box>
    )}

            <Typography variant="body2" align="center">
              Don't have an account?{' '}
              <Button
                component={Link}
                to="/signup"
                color="primary"
                
                onClick= {() =>  {
                  setUserData(null); // Reset userData so they can register again
                  navigate("/signup"); // Redirect to signup
                }}
                sx={{ textTransform: 'none' }}
              >
                Register an account
              </Button>
            </Typography>
          </Box>

          </div>
        </CardContent>
      </StyledCard>
      {/* Dialog Component for Application Already Submitted
  <Dialog open={openPopup} onClose={handleClose}>
    <DialogTitle>Application Already Submitted</DialogTitle>
    <DialogContent>
      <Typography>Your application has already been submitted.</Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose} color="primary">OK</Button>
    </DialogActions>
  </Dialog> */}
  {/* {openPopup && <SubmittedMessage onClose={handleClose} />} */}
  {openPopup && (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark semi-transparent overlay
        backdropFilter: "blur(5px)", // Apply blur effect
        zIndex: 1200, // Ensure it's behind the popup but above other content
      }}
    />
  )}
  {openPopup && <SubmittedMessage onClose={handleClose} />}

    </ThemeProvider>
  );
};

export default LoginForm;